var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"max-w-full",attrs:{"src":_vm.image}})}
var staticRenderFns = []

export { render, staticRenderFns }